import { EmoteGlyph } from '../emotes/glyphs';
import type { EmoteDef } from '../emotes/registry';
import { getEmoteDef } from '../emotes/registry';

export type EmoteIconProps = {
  emoteId?: string | null;
  emote?: EmoteDef;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

const sizeClass = {
  sm: 'h-7 w-7',
  md: 'h-10 w-10',
  lg: 'h-14 w-14',
} as const;

const inkClass = {
  victory: 'text-bk-gold-bright',
  defeat: 'text-rose-200',
  salute: 'text-sky-200',
  laugh: 'text-amber-200',
  glare: 'text-rose-100',
  crown: 'text-bk-gold-bright',
  bow: 'text-teal-200',
  rage: 'text-red-200',
  smirk: 'text-sky-200',
} as const;

export default function EmoteIcon({
  emoteId,
  emote,
  size = 'md',
  className = '',
}: EmoteIconProps) {
  const def = emote ?? getEmoteDef(emoteId);
  if (!def) return null;

  return (
    <span
      className={[
        'inline-flex shrink-0 overflow-hidden rounded-full shadow-[inset_0_1px_0_rgba(255,255,255,0.12),0_1px_2px_rgba(0,0,0,0.45)]',
        sizeClass[size],
        inkClass[def.iconKey],
        className,
      ].join(' ')}
      title={def.label}
      aria-label={def.label}
    >
      <EmoteGlyph iconKey={def.iconKey} className="h-full w-full" />
    </span>
  );
}
